const releasesValidationDE = {
    "add": {
        "releaseName": {
            "required": 'Der Veröffentlichungsname ist erforderlich',
            "length": 'Der Veröffentlichungsname muss mehr als 2 und weniger als 120 Zeichen lang sein',
            "noForwardSlash": 'Der Veröffentlichungsname darf keinen Schrägstrich (/) enthalten',
            "matchTrack": 'Bei einer Veröffentlichung mit einem Song sollte der Veröffentlichungsname mit dem Track übereinstimmen.',
            // validCharacters: 'Der Veröffentlichungsname darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen'
            },
            "releaseVersion": {
                "length": 'Die Veröffentlichungsversion muss mehr als 2 und weniger als 120 Zeichen lang sein',
                "validCharacters": 'Die Veröffentlichungsversion darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen',
                "missingOne": 'Ihre Veröffentlichung besteht aus nur einem Track, der kein Original Mix ist, daher muss der benutzerdefinierte Track-Mix-Name in die Veröffentlichungsversion eingefügt werden.',
                "missingTwo": 'Wenn eine Veröffentlichung mehr Inhalte als die Standardversion bietet oder es sich um eine andere Version eines bereits veröffentlichten Albums/Veröffentlichung handelt, müssen Sie die Veröffentlichungsversion einfügen.',
                "invalid": 'Bei einer Veröffentlichung mit einem Song ohne Mix-Name (Original Mix) sollte die Veröffentlichungsversion leer bleiben. Bitte entweder die Veröffentlichungsversion löschen oder einen Mix-Name zum Song hinzufügen.'
            },
            "releaseLanguage": {
                "required": 'Veröffentlichungssprache ist erforderlich. Bitte wählen Sie die Sprache Ihres Veröffentlichungsnamens.'
            },
            "releaseLabel": {
                "required": 'Bitte wählen Sie Ihr Label aus.'
            },
            "releaseCopyright": {
                "required": 'Sie müssen den Copyright-Inhaber angeben. In der Regel ist es Ihr Label.'
            },
            "releaseCopyrightYear": {
                "required": 'Bitte geben Sie das Jahr des Copyrights ein, in dem diese Veröffentlichung veröffentlicht wird (wurde).',
                "regexp": 'Bitte geben Sie das gültige Copyright-Jahr ein'
            },
            "releaseCopyrightPublisher": {
                "required": 'Sie müssen den Publisher-Inhaber angeben. In der Regel ist es Ihr Label.'
            },
            "releaseCopyrightYearPublisher": {
                "required": 'Bitte geben Sie das Jahr des Copyrights ein, in dem diese Veröffentlichung veröffentlicht wird (wurde).',
                "regexp": 'Bitte geben Sie das gültige Copyright-Jahr ein'
            },
            "releaseGenre": {
                "required": 'Bitte wählen Sie Ihr Veröffentlichungsgenre aus.'
            },
            "releaseSubGenre": {
                "required": 'Bitte wählen Sie Ihr Veröffentlichungs-Subgenre aus'
            },
            "releaseCatalogNumber": {
                "required": 'Fügen Sie eine eindeutige Veröffentlichungs-Katalognummer ein.',
                "length": 'Mindestens 4 und maximal 16 Zeichen.',
                "validFormat": 'Bitte geben Sie Ihre Kategorienummer ohne Leerzeichen ein, nur GROSSBUCHSTABEN und Zahlen. Die ersten beiden Zeichen müssen GROSSBUCHSTABEN sein. MM001, MMD001, MM0001 ... '
            },
            "releaseDescription": {
                // required: 'Eine gute und professionelle Veröffentlichungsbeschreibung kann einen Unterschied machen.',
                "length": 'Eine Veröffentlichungsbeschreibung muss mindestens 100 und maximal 600 Zeichen lang sein.'
            },
            "releaseArtwork": {
                "required": 'Das Artwork ist erforderlich',
                "wrongSpecsAndColor": 'Falsche Bildspezifikationen und Farbformat. Die Größe des Veröffentlichungs-Covers muss genau 3000 x 3000 px, RGB-Farben, JPG, maximale Dateigröße 4 MB sein.',
                "wrongColorFormat": 'Falsches Bildfarbformat. Das Veröffentlichungs-Cover muss in RGB-Farben sein. JPG, maximale Dateigröße 4 MB.',
                "wrongSpecs": 'Falsche Bildspezifikationen. Die Größe des Veröffentlichungs-Covers muss genau 3000 x 3000 px sein. JPG, maximale Dateigröße 4 MB.',
                "meetsSpecs": 'Bild erfüllt alle Spezifikationen.',
                "chooseImage": 'Bitte wählen Sie ein Bild aus',
                "fileTooLarge": 'Die ausgewählte Datei ist größer als 4 MB. Bitte laden Sie das Cover in 3000x3000 px, JPG, RGB-Farben, maximale Dateigröße 4 MB hoch',
                "wrongExtension": 'Falsche Dateierweiterung. Die ausgewählte Datei hat die Erweiterung ".jpeg". Bitte laden Sie das Cover in 3000x3000 px, JPG (nur ".jpg"-Erweiterung), RGB-Farben, maximale Dateigröße 4 MB hoch'
            },
            "releaseTerritories": {
                "required": 'Bitte wählen Sie Gebiete aus.'
            },
            "atleastOneCountrySelected": {
                "required": 'Bitte wählen Sie mindestens ein Land aus.'
            },
            "atleastOneContentIDChoiceSelected": {
                "required": 'Die Youtube Content ID-Erklärung ist obligatorisch, bitte wählen Sie eine der oben genannten Optionen.'
            },
            "originalReleaseDate": {
                "required": 'Bitte wählen Sie das ursprüngliche Veröffentlichungsdatum für alle Shops weltweit aus.'
            },
            "officialReleaseDate": {
                "required": 'Bitte wählen Sie das offizielle Veröffentlichungsdatum für alle Shops weltweit aus.'
            },
            "atleastOneMainArtist": {
                "required": 'Mindestens ein Künstler muss Hauptkünstler sein'
            },
            "featuringArtistMissing": {
                "required": 'Die Veröffentlichung muss den im Titel aufgeführten Künstler korrekt als Featuring-Künstlerrolle zugewiesen haben. Bitte ändern und erneut einreichen.'
            },
            "duplicateArtists": {
                "required": 'Es gibt zwei oder mehr Künstler mit demselben Namen.'
            },
            "artistName": {
                "required": 'Bitte wählen Sie einen Künstler aus'
            },
            "artistType": {
                "required": 'Bitte wählen Sie den Künstler-Typ aus'
            },
            "trackName": {
                "required": 'Bitte geben Sie den Tracknamen ein'
            },
            "trackMixName": {
                "required": 'Bitte geben Sie den Mix-Namen ein',
                "regexp": 'Der Mix-Name darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen'
            }
    },
    "update": {
        "releaseName": {
            "required": 'Der Veröffentlichungsname ist erforderlich',
            "length": 'Der Veröffentlichungsname muss mehr als 2 und weniger als 120 Zeichen lang sein',
            "noForwardSlash": 'Der Veröffentlichungsname darf keinen Schrägstrich (/) enthalten',
            "matchTrack": 'Bei einer Veröffentlichung mit einem Song sollte der Veröffentlichungsname mit dem Track übereinstimmen.',
            "validCharacters": 'Der Veröffentlichungsname darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen'
        },
        "releaseVersion": {
            "length": 'Die Veröffentlichungsversion muss mehr als 2 und weniger als 120 Zeichen lang sein',
            "validCharacters": 'Die Veröffentlichungsversion darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen',
            "missingOne": 'Ihre Veröffentlichung besteht aus nur einem Track, der kein Original Mix ist, daher muss der benutzerdefinierte Track-Mix-Name in die Veröffentlichungsversion eingefügt werden.',
            "missingTwo": 'Wenn eine Veröffentlichung mehr Inhalte als die Standardversion bietet oder es sich um eine andere Version eines bereits veröffentlichten Albums/Veröffentlichung handelt, müssen Sie die Veröffentlichungsversion einfügen.',
            "invalid": 'Bei einer Veröffentlichung mit einem Song ohne Mix-Name (Original Mix) sollte die Veröffentlichungsversion leer bleiben. Bitte entweder die Veröffentlichungsversion löschen oder einen Mix-Name zum Song hinzufügen.'
        },
        "releaseLanguage": {
            "required": 'Veröffentlichungssprache ist erforderlich. Bitte wählen Sie die Sprache Ihres Veröffentlichungsnamens.'
        },
        "releaseEAN_UPC": {
            "required": "EAN / UPC ist erforderlich.",
            "length": "Die EAN-Nummer muss genau 13 Zeichen lang sein.",
            "isValidEAN": "Der Wert ist keine gültige EAN. Wenn Sie eine neue Veröffentlichung hinzufügen, geben Sie bitte eine gültige EAN ein. Wenn Sie einen Backkatalog hochladen und die EAN ungültig ist, kontaktieren Sie uns bitte."
        },
        "releaseLabel": {
            "required": 'Bitte wählen Sie Ihr Label aus.'
        },
        "releaseCopyright": {
            "required": 'Sie müssen den Copyright-Inhaber auswählen. In der Regel ist es Ihr Label.'
        },
        "releaseCopyrightYear": {
            "required": 'Bitte geben Sie das Jahr des Copyrights ein, in dem diese Veröffentlichung veröffentlicht wird (wurde).',
            "regexp": 'Bitte geben Sie das gültige Copyright-Jahr ein'
        },
        "releaseCopyrightPublisher": {
            "required": 'Sie müssen den Publisher-Inhaber angeben. In der Regel ist es Ihr Label.'
        },
        "releaseCopyrightYearPublisher": {
            "required": 'Bitte geben Sie das Jahr des Copyrights ein, in dem diese Veröffentlichung veröffentlicht wird (wurde).',
            "regexp": 'Bitte geben Sie das gültige Copyright-Jahr ein'
        },
        "releaseGenre": {
            "required": 'Bitte wählen Sie Ihr Veröffentlichungsgenre aus.'
        },
        "releaseSubGenre": {
            "required": 'Bitte wählen Sie Ihr Veröffentlichungs-Subgenre aus'
        },
        "releaseCatalogNumber": {
            "required": 'Fügen Sie eine eindeutige Veröffentlichungs-Katalognummer ein.',
            "length": 'Mindestens 4 und maximal 16 Zeichen.',
            "validFormat": 'Bitte geben Sie Ihre Kategorienummer ohne Leerzeichen ein, nur GROSSBUCHSTABEN und Zahlen. Die ersten beiden Zeichen müssen GROSSBUCHSTABEN sein. MM001, MMD001, MM0001 ...'
        },
        "releaseDescription": {
            "length": 'Eine Veröffentlichungsbeschreibung muss mindestens 100 und maximal 600 Zeichen lang sein.'
        },
        "releaseArtwork": {
            "required": 'Das Artwork ist erforderlich',
            "wrongSpecsAndColor": 'Falsche Bildspezifikationen und Farbformat. Die Größe des Veröffentlichungs-Covers muss genau 3000 x 3000 px, RGB-Farben, JPG, maximale Dateigröße 4 MB sein.',
            "wrongColorFormat": 'Falsches Bildfarbformat. Das Veröffentlichungs-Cover muss in RGB-Farben sein. JPG, maximale Dateigröße 4 MB.',
            "wrongSpecs": 'Falsche Bildspezifikationen. Die Größe des Veröffentlichungs-Covers muss genau 3000 x 3000 px sein. JPG, maximale Dateigröße 4 MB.',
            "meetsSpecs": 'Bild erfüllt alle Spezifikationen.',
            "chooseImage": 'Bitte wählen Sie ein Bild aus',
            "fileTooLarge": 'Die ausgewählte Datei ist größer als 4 MB. Bitte laden Sie das Cover in 3000x3000 px, JPG, RGB-Farben, maximale Dateigröße 4 MB hoch',
            "wrongExtension": 'Falsche Dateierweiterung. Die ausgewählte Datei hat die Erweiterung ".jpeg". Bitte laden Sie das Cover in 3000x3000 px, JPG (nur ".jpg"-Erweiterung), RGB-Farben, maximale Dateigröße 4 MB hoch'
        },
        "releaseTerritories": {
            "required": 'Bitte wählen Sie Gebiete aus.'
        },
        "atleastOneCountrySelected": {
            "required": 'Bitte wählen Sie mindestens ein Land aus.'
        },
        "atleastOneContentIDChoiceSelected": {
            "required": 'Die Youtube Content ID-Erklärung ist obligatorisch, bitte wählen Sie eine der oben genannten Optionen.'
        },
        "originalReleaseDate": {
            "required": 'Bitte wählen Sie das ursprüngliche Veröffentlichungsdatum für alle Shops weltweit aus.'
        },
        "officialReleaseDate": {
            "required": 'Bitte wählen Sie das offizielle Veröffentlichungsdatum für alle Shops weltweit aus.'
        },
        "atleastOneMainArtist": {
            "required": 'Mindestens ein Künstler muss Hauptkünstler sein'
        },
        "featuringArtistMissing": {
            "required": 'Die Veröffentlichung muss den im Titel aufgeführten Künstler korrekt als Featuring-Künstlerrolle zugewiesen haben. Bitte ändern und erneut einreichen.'
        },
        "duplicateArtists": {
            "required": 'Es gibt zwei oder mehr Künstler mit demselben Namen.'
        },
        "artistName": {
            "required": 'Bitte wählen Sie einen Künstler aus'
        },
        "artistType": {
            "required": 'Bitte wählen Sie den Künstler-Typ aus'
        },
        "trackName": {
            "required": 'Bitte geben Sie den Tracknamen ein'
        },
        "trackMixName": {
            "required": 'Bitte geben Sie den Mix-Namen ein',
            "regexp": 'Der Mix-Name darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen'
        }
    },
    "transfer": {
        "releaseName": {
            "required": "Der Veröffentlichungsname ist erforderlich",
            "length": "Der Veröffentlichungsname muss zwischen 2 und 120 Zeichen lang sein",
            "invalid": "Der Veröffentlichungsname darf keinen Schrägstrich (/) enthalten"
        },
        "releaseVersion": {
            "length": "Die Veröffentlichungsversion muss mehr als 2 und weniger als 120 Zeichen lang sein",
            "regexp": "Die Veröffentlichungsversion darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen",
            "missingOne": "Ihre Veröffentlichung besteht aus nur einem Track, der kein Original Mix ist, daher muss der benutzerdefinierte Track-Mix-Name in die Veröffentlichungsversion eingefügt werden.",
            "missingTwo": "Wenn eine Veröffentlichung mehr Inhalte als die Standardversion bietet oder es sich um eine andere Version eines bereits veröffentlichten Albums/Veröffentlichung handelt, müssen Sie die Veröffentlichungsversion einfügen.",
            "invalid": "Bei einer Veröffentlichung mit einem Song ohne Mix-Name (Original Mix) sollte die Veröffentlichungsversion leer bleiben. Bitte entweder die Veröffentlichungsversion löschen oder einen Mix-Name zum Song hinzufügen."
        },
        "releaseLanguage": {
            "required": "Veröffentlichungssprache ist erforderlich. Bitte wählen Sie die Sprache Ihres Veröffentlichungsnamens."
        },
        "releaseEAN_UPC": {
            "required": "EAN / UPC ist erforderlich.",
            "length": "Die EAN-Nummer muss genau 13 Zeichen lang sein.",
            "isValidEAN": "Der Wert ist keine gültige EAN. Wenn Sie eine neue Veröffentlichung hinzufügen, geben Sie bitte eine gültige EAN ein. Wenn Sie einen Backkatalog hochladen und die EAN ungültig ist, kontaktieren Sie uns bitte."
        },
        "releaseLabel": {
            "required": "Bitte wählen Sie Ihr Label aus."
        },
        "releaseCopyright": {
            "required": "Sie müssen den Copyright-Inhaber angeben. In der Regel ist es Ihr Label."
        },
        "releaseCopyrightYear": {
            "required": "Bitte geben Sie das Jahr des Copyrights ein, in dem diese Veröffentlichung veröffentlicht wird (wurde).",
            "regexp": "Bitte geben Sie das gültige Copyright-Jahr ein"
        },
        "releaseCopyrightPublisher": {
            "required": "Sie müssen den Publisher-Inhaber angeben. In der Regel ist es Ihr Label."
        },
        "releaseCopyrightYearPublisher": {
            "required": "Bitte geben Sie das Jahr des Copyrights ein, in dem diese Veröffentlichung veröffentlicht wird (wurde).",
            "regexp": "Bitte geben Sie das gültige Copyright-Jahr ein"
        },
        "releaseGenre": {
            "required": "Bitte wählen Sie Ihr Veröffentlichungsgenre aus."
        },
        "releaseSubGenre": {
            "required": "Bitte wählen Sie Ihr Veröffentlichungs-Subgenre aus."
        },
        "releaseCatalogNumber": {
            "required": "Fügen Sie eine eindeutige Veröffentlichungs-Katalognummer ein.",
            "length": "Mindestens 4 und maximal 16 Zeichen.",
            "regexp": "Bitte geben Sie Ihre Kategorienummer ohne Leerzeichen ein, nur GROSSBUCHSTABEN und Zahlen. Die ersten beiden Zeichen müssen GROSSBUCHSTABEN sein. MM001, MMD001, MM0001 ... "
        },
        "releaseDescription": {
            "length": "Eine Veröffentlichungsbeschreibung muss mindestens 100 und maximal 600 Zeichen lang sein."
        },
        "releaseArtwork": {
            "required": "Das Artwork ist erforderlich",
            "invalidDimensionsAndColorFormat": "Falsche Bildspezifikationen und Farbformat. Die Größe des Veröffentlichungs-Covers muss genau 3000 x 3000 px, RGB-Farben, JPG, maximale Dateigröße 4 MB sein.",
            "invalidColorFormat": "Falsches Bildfarbformat. Das Veröffentlichungs-Cover muss in RGB-Farben sein. JPG, maximale Dateigröße 4 MB.",
            "invalidDimensions": "Falsche Bildspezifikationen. Die Größe des Veröffentlichungs-Covers muss genau 3000 x 3000 px sein. JPG, maximale Dateigröße 4 MB.",
            "valid": "Bild erfüllt alle Spezifikationen",
            "choose": "Bitte wählen Sie ein Bild aus",
            "fileSize": "Die ausgewählte Datei ist größer als 4 MB. Bitte laden Sie das Cover in 3000x3000 px, JPG, RGB-Farben, maximale Dateigröße 4 MB hoch",
            "fileExtension": "Falsche Dateierweiterung. Die ausgewählte Datei hat die Erweiterung '.jpeg'. Bitte laden Sie das Cover in 3000x3000 px, JPG (nur '.jpg'-Erweiterung), RGB-Farben, maximale Dateigröße 4 MB hoch"
        },
        "releaseTerritories": {
            "required": "Bitte wählen Sie Gebiete aus."
        },
        "atleastOneCountrySelected": {
            "required": "Bitte wählen Sie mindestens ein Land aus."
        },
        "atleastOneContentIDChoiceSelected": {
            "required": "Die Youtube Content ID-Erklärung ist obligatorisch, bitte wählen Sie eine der oben genannten Optionen."
        },
        "originalReleaseDate": {
            "required": "Bitte wählen Sie das ursprüngliche Veröffentlichungsdatum für alle Shops weltweit aus."
        },
        "officialReleaseDate": {
            "required": "Bitte wählen Sie das offizielle Veröffentlichungsdatum für alle Shops weltweit aus."
        },
        "atleastOneMainArtist": {
            "required": "Mindestens ein Künstler muss Hauptkünstler sein"
        },
        "artistType": {
            "required": "Bitte wählen Sie den Künstler-Typ aus"
        },
        "trackName": {
            "required": "Bitte geben Sie den Tracknamen ein"
        },
        "trackMixName": {
            "required": "Bitte geben Sie den Mix-Namen ein",
            "regexp": "Der Mix-Name darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen"
        }
    }
};

export default releasesValidationDE;